/* DietXP exchange view, 30 Sep 2026 (owner: "Indian logic for Indian people, US logic for US people").
 * Shows the finished plan as food exchanges, Indian or US system, with carb choices and "swap within a group" lists.
 * Reads the planner's report model (window.DietXP.getReportModel) and api.dietxp.com/v1/exchanges (approved groups
 * only). It never changes the plan and removes itself if anything is missing. Plain ES2017, no dependencies.
 * window.DietXPExchanges.summary(model) gives the PDF report the same week as plain data (30 Sep 2026). */
(function () {
  'use strict';
  var API_FALLBACK = 'https://api.dietxp.com';
  var STORE_KEY = 'dxp_exchange_system';
  var LABELS = {
    IN_CEREAL: 'Cereal', IN_PULSE: 'Pulse', IN_SOY: 'Soybean', IN_MILK: 'Milk and curd', IN_PANEER: 'Paneer and tofu',
    IN_VEG_A: 'Vegetable A', IN_VEG_B: 'Vegetable B', IN_VEG_C: 'Vegetable C (starchy)', IN_FRUIT: 'Fruit', IN_NUTS: 'Nuts and seeds',
    IN_FAT: 'Fat', IN_SUGAR: 'Sugar',
    US_STARCH: 'Starch', US_PLANT_PROTEIN: 'Beans and lentils', US_PROTEIN: 'Protein', US_MILK: 'Milk',
    US_NONSTARCHY: 'Nonstarchy vegetable', US_FRUIT: 'Fruit', US_FAT: 'Fat', US_SWEETS: 'Sweets'
  };
  var ORDER = ['IN_CEREAL', 'IN_PULSE', 'IN_SOY', 'IN_PANEER', 'IN_MILK', 'IN_VEG_A', 'IN_VEG_B', 'IN_VEG_C', 'IN_FRUIT', 'IN_NUTS', 'IN_FAT', 'IN_SUGAR',
    'US_STARCH', 'US_PLANT_PROTEIN', 'US_PROTEIN', 'US_MILK', 'US_NONSTARCHY', 'US_FRUIT', 'US_FAT', 'US_SWEETS'];
  var INTRO = {
    IN: 'An exchange is an amount of food that gives about the same nutrition as the other foods in its group. Swap foods within a group, ' +
      'for example 1 cereal exchange of rice for 1 of bajra, and your plan stays balanced. 1 cereal or pulse exchange is 30 g raw (about 100 kcal), ' +
      '1 vegetable exchange 100 g, 1 fruit exchange about 100 kcal, 1 fat exchange 5 g. Amounts come from each food\'s own IFCT 2017 values.',
    US: 'US exchange lists (as in "Choose Your Foods", American Diabetes Association and Academy of Nutrition and Dietetics): 1 starch or 1 fruit ' +
      'is 15 g carbohydrate, 1 milk 12 g carbohydrate, 1 nonstarchy vegetable 5 g, 1 protein 7 g protein, 1 fat 5 g fat. Carbohydrate is counted ' +
      'as total carbohydrate (available carbohydrate plus fibre). Weights are raw, with ounces.'
  };
  var cache = {};
  var state = { system: null, day: 0, key: '', busy: false };

  function apiBase() {
    var el = document.querySelector('.dxp-calculator[data-apps-script-url]');
    try { return el ? new URL(el.getAttribute('data-apps-script-url')).origin : API_FALLBACK; } catch (e) { return API_FALLBACK; }
  }
  function defaultSystem() {
    try { var s = window.localStorage.getItem(STORE_KEY); if (s === 'IN' || s === 'US') { return s; } } catch (e) { /* storage blocked */ }
    return (window.Shopify && window.Shopify.country === 'US') ? 'US' : 'IN';
  }
  function remember(s) { try { window.localStorage.setItem(STORE_KEY, s); } catch (e) { /* storage blocked */ } }
  function load(system) {
    if (cache[system]) { return Promise.resolve(cache[system]); }
    return fetch(apiBase() + '/v1/exchanges?system=' + system + '&v=2026-10-06-intelligence-v18o', { credentials: 'omit' })
      .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.json(); })
      .then(function (d) {
        if (!d || !d.recipes) { throw new Error('no data'); }
        var rx = {};
        d.recipes.forEach(function (r) { rx[r.recipe_id] = r; });
        d.byRecipe = rx;
        cache[system] = d;
        return d;
      });
  }
  function model() {
    try { var m = window.DietXP && window.DietXP.getReportModel && window.DietXP.getReportModel(); return m && m.days && m.days.length ? m : null; } catch (e) { return null; }
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) { e.className = cls; }
    if (text != null) { e.textContent = text; }
    return e;
  }
  function amount(x) {
    var r = Math.round(x * 2) / 2;
    if (r === 0) { return x >= 0.1 ? 'less than ½' : ''; }
    var w = Math.floor(r);
    return (w ? String(w) : '') + (r - w ? '½' : '');
  }
  function shortName(n) { return String(n || '').replace(/\s*\(.*?\)\s*/g, ' ').replace(/\s+/g, ' ').trim(); }
  function grams(system, gid, g, hasMeasure) {
    if (g == null) { return ''; }
    var t = Math.round(g) + ' g';
    if (system !== 'US') { return t; }
    if (gid === 'US_MILK') {
      if (hasMeasure) { return t; }   /* the food's own measure ("about 1 cup") follows */
      var cups = Math.round(g / 244 * 4) / 4;
      return t + ' (about ' + cups + (cups > 1 ? ' cups)' : ' cup)');
    }
    return t + ' (' + (Math.round(g / 28.35 * 10) / 10) + ' oz)';
  }
  function mealExchanges(meal, rx) {
    var tot = {}, carb = 0, known = true, any = false, held = false, missingRecipe = false;
    (meal.items || []).forEach(function (it) {
      var r = rx[it.rid], sv = Number(it.sv) || 1;
      if (!r) { known = false; if (/^DXR\d{5}$/.test(it.rid || '')) { any = true; missingRecipe = true; } return; }
      any = true;
      if (r.pending && r.pending.length) { held = true; }
      Object.keys(r.exchanges || {}).forEach(function (g) { tot[g] = (tot[g] || 0) + r.exchanges[g] * sv; });
      if (r.carb_choices == null) { known = false; } else { carb += r.carb_choices * sv; }
    });
    return { tot: tot, carb: any && known ? carb : null, any: any, held: held, missingRecipe: missingRecipe };
  }
  function line(tot) {
    return ORDER.filter(function (g) { return tot[g] && amount(tot[g]); })
      .map(function (g) { return (LABELS[g] || g) + ' ' + amount(tot[g]); }).join(' · ');
  }
  /* a dish with egg, meat or fish keeps its other exchanges; the held part is named, never counted as zero */
  function mealText(r) {
    var t = line(r.tot);
    if (r.missingRecipe) { t = t ? 'Partial: ' + t + ' · new recipe exchanges unavailable' : 'New recipe exchanges unavailable'; }
    if (r.held) { t = t ? t + ' · egg, meat or fish not counted yet' : 'Egg, meat or fish: not counted as exchanges yet'; }
    return t || 'Not shown as exchanges yet';
  }
  function half(x) { return Math.round(x * 2) / 2; }
  function basisText(g) {
    return g.basis === 'energy_kcal' ? 'about ' + g.amount + ' kcal' : g.basis === 'carb_total_g' ? g.amount + ' g carbohydrate'
      : g.basis === 'protein_g' ? g.amount + ' g protein' : g.basis === 'fat_g' ? g.amount + ' g fat'
      : g.basis === 'mass_raw_g' ? g.amount + ' g raw' : g.amount + ' g';
  }
  function foodDetail(system, gid, x) {
    var p = x.at_portion || {};
    var bits = [grams(system, gid, x.grams, !!(x.extra && x.extra.measure))];
    if (x.extra && x.extra.measure) { bits.push(x.extra.measure); }
    if (p.energy_kcal != null) { bits.push(Math.round(p.energy_kcal) + ' kcal'); }
    if (p.protein_g != null) { bits.push((Math.round(p.protein_g * 10) / 10) + ' g protein'); }
    return bits.filter(Boolean).join(' · ');
  }
  function carbNote(system) {
    return 'Carb choices are 15 g carbohydrate each (' + (system === 'US' ? 'total' : 'available') +
      ' carbohydrate). They help people with diabetes count carbohydrate; your doctor or dietitian sets your own target.';
  }
  var HELD_NOTE = 'Egg, meat and fish are not shown as exchanges yet: their values are being reviewed.';
  var PDF_LIST_MAX = 24;   /* foods per group in the PDF; the card lists them all */
  /* US lists: the everyday US foods (USDA FoodData Central) first, then the Indian foods; each part keeps its order */
  function membersOf(data, gid, system) {
    var list = (data.members || []).filter(function (x) { return x.group_id === gid; });
    if (system !== 'US') { return list; }
    var usda = function (x) { return /^USDA_/.test(String(x.food_code || '')); };
    return list.filter(usda).concat(list.filter(function (x) { return !usda(x); }));
  }
  var GUIDE_NOTE = 'Exchanges are a guide for swapping foods. Your full plan, with its amounts, stays the reference.';
  function anchor(res) {
    var weekly = res.querySelector('[id^="dxpWeeklyDetailsPanel"]');
    var card = weekly && weekly.closest ? weekly.closest('.dxp-card') : null;
    if (card && card.parentNode === res) { return card.nextSibling; }
    var fb = res.querySelector('.dxp-feedback-card');
    return fb && fb.parentNode === res ? fb : null;
  }

  function weekHeld(m, data) {
    return m.days.some(function (d) {
      return (d.meals || []).some(function (meal) {
        return (meal.items || []).some(function (it) { var r = data.byRecipe[it.rid]; return !!(r && r.pending && r.pending.length); });
      });
    });
  }

  /* The whole week as plain data for the PDF report (dietxp-plan-report.js), in the system chosen on the card. */
  function summary(m) {
    m = m || model();
    if (!m || !m.days || !m.days.length) { return Promise.resolve(null); }
    var system = state.system || defaultSystem();
    return load(system).then(function (data) {
      var used = {};
      var days = m.days.map(function (d, i) {
        var dayTot = {}, dayCarb = 0, carbKnown = true, meals = [], missingRecipe = false;
        (d.meals || []).forEach(function (meal) {
          var r = mealExchanges(meal, data.byRecipe);
          if (!r.any) { return; }
          if (r.missingRecipe) { missingRecipe = true; }
          Object.keys(r.tot).forEach(function (g) { dayTot[g] = (dayTot[g] || 0) + r.tot[g]; used[g] = true; });
          if (r.carb == null) { carbKnown = false; } else { dayCarb += r.carb; }
          meals.push({ label: meal.label || meal.slotId || '', text: r.missingRecipe ? mealText(r) : line(r.tot), carb: r.carb == null ? null : half(r.carb), held: r.held });
        });
        return { day: d.day || ('Day ' + (i + 1)), meals: meals, text: (missingRecipe ? 'Partial: ' : '') + (line(dayTot) || (missingRecipe ? 'new recipe exchanges unavailable' : 'none')), carb: carbKnown ? half(dayCarb) : null };
      });
      var byId = {};
      (data.groups || []).forEach(function (g) { byId[g.group_id] = g; });
      var groups = ORDER.filter(function (g) { return used[g] && byId[g]; }).map(function (gid) {
        var g = byId[gid];
        var hint = g.measure_hint && /\d/.test(g.measure_hint) ? g.measure_hint : '';
        var foods = membersOf(data, gid, system).map(function (x) { return { name: shortName(x.food_name), detail: foodDetail(system, gid, x) }; });
        return {
          id: gid, label: LABELS[gid] || g.label, basis: basisText(g),
          about: [g.about, g.rule, hint].filter(Boolean).join(' · '),
          foods: foods.slice(0, PDF_LIST_MAX), more: Math.max(0, foods.length - PDF_LIST_MAX)
        };
      }).filter(function (g) { return g.foods.length; });
      return {
        system: system,
        systemLabel: system === 'US' ? 'US exchange lists (Choose Your Foods, American Diabetes Association and Academy of Nutrition and Dietetics)'
          : 'Indian exchange system · food values from IFCT 2017',
        source: system === 'US' ? 'Food exchanges: US exchange lists (Choose Your Foods, ADA and Academy of Nutrition and Dietetics), amounts from IFCT 2017 food values'
          : 'Food exchanges: Indian exchange system, amounts from IFCT 2017 food values with ICMR-NIN DGI 2024 household measures',
        intro: INTRO[system], days: days, groups: groups, carbNote: carbNote(system),
        heldNote: weekHeld(m, data) ? 'Meals tagged "+ egg, meat or fish": the egg, meat or fish in them is not counted as exchanges yet because ' +
          'those values are being reviewed, so the carb choices for those meals and days are not shown either.' : '',
        guideNote: GUIDE_NOTE, version: data.exchange_version || ''
      };
    });
  }

  function render(m, data) {
    var res = document.getElementById('dxpResults');
    if (!res) { return; }
    var old = document.getElementById('dxpExchangeCard');
    var system = state.system;
    if (state.day >= m.days.length) { state.day = 0; }
    var day = m.days[state.day];
    var card = el('section', 'dxp-card dxp-exchange-card');
    card.id = 'dxpExchangeCard';
    card.setAttribute('aria-labelledby', 'dxpExchangeTitle');
    var head = el('div', 'dxx-head');
    var h = el('h3', 'dxx-title', 'Your plan as food exchanges');
    h.id = 'dxpExchangeTitle';
    head.appendChild(h);
    var sw = el('div', 'dxx-switch');
    sw.setAttribute('role', 'group');
    sw.setAttribute('aria-label', 'Exchange system');
    [['IN', 'Indian exchanges'], ['US', 'US exchanges']].forEach(function (o) {
      var b = el('button', 'dxx-sys', o[1]);
      b.type = 'button';
      b.setAttribute('aria-pressed', o[0] === system ? 'true' : 'false');
      b.addEventListener('click', function () {
        if (state.system === o[0]) { return; }
        state.system = o[0];
        remember(o[0]);
        refresh(true);
      });
      sw.appendChild(b);
    });
    head.appendChild(sw);
    card.appendChild(head);
    card.appendChild(el('p', 'dxx-intro', INTRO[system]));

    var pick = el('label', 'dxx-day', 'Day ');
    var sel = el('select', 'dxx-day-select');
    m.days.forEach(function (d, i) {
      var o = el('option', null, d.day || ('Day ' + (i + 1)));
      o.value = String(i);
      if (i === state.day) { o.selected = true; }
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () { state.day = Number(sel.value) || 0; refresh(true); });
    pick.appendChild(sel);
    card.appendChild(pick);

    var list = el('ul', 'dxx-meals');
    var dayTot = {}, dayCarb = 0, carbKnown = true, used = {}, missingRecipe = false;
    (day.meals || []).forEach(function (meal) {
      var r = mealExchanges(meal, data.byRecipe);
      if (!r.any) { return; }
      if (r.missingRecipe) { missingRecipe = true; }
      Object.keys(r.tot).forEach(function (g) { dayTot[g] = (dayTot[g] || 0) + r.tot[g]; used[g] = true; });
      if (r.carb == null) { carbKnown = false; } else { dayCarb += r.carb; }
      var li = el('li', 'dxx-meal');
      li.appendChild(el('strong', 'dxx-meal-name', meal.label || meal.slotId || ''));
      li.appendChild(el('span', 'dxx-meal-ex', mealText(r)));
      if (r.carb != null) { li.appendChild(el('span', 'dxx-meal-carb', half(r.carb) + ' carb choices')); }
      list.appendChild(li);
    });
    card.appendChild(list);
    card.appendChild(el('p', 'dxx-total', 'Day total: ' + (missingRecipe ? 'Partial: ' : '') + (line(dayTot) || (missingRecipe ? 'new recipe exchanges unavailable' : 'none')) +
      (carbKnown ? ' · ' + half(dayCarb) + ' carb choices' : '')));
    card.appendChild(el('p', 'dxx-small', carbNote(system)));

    var swaps = el('div', 'dxx-swaps');
    swaps.appendChild(el('h4', 'dxx-sub', 'Swap within a group'));
    var groups = {};
    (data.groups || []).forEach(function (g) { groups[g.group_id] = g; });
    ORDER.filter(function (g) { return used[g] && groups[g]; }).forEach(function (gid) {
      var members = membersOf(data, gid, system);
      if (!members.length) { return; }
      var d = el('details', 'dxx-group');
      d.appendChild(el('summary', null, (LABELS[gid] || groups[gid].label) + ': 1 exchange = ' + basisText(groups[gid])));
      var ul = el('ul', 'dxx-foods');
      members.forEach(function (x) { ul.appendChild(el('li', null, shortName(x.food_name) + ': ' + foodDetail(system, gid, x))); });
      d.appendChild(ul);
      swaps.appendChild(d);
    });
    card.appendChild(swaps);
    if (weekHeld(m, data)) {
      card.appendChild(el('p', 'dxx-small', HELD_NOTE));
    }
    card.appendChild(el('p', 'dxx-small', 'Exchanges are a guide for swapping foods. Your full plan above, with its amounts, stays the reference.'));

    if (old && old.parentNode) {
      old.parentNode.replaceChild(card, old);
    } else {
      res.insertBefore(card, anchor(res));
    }
  }

  function refresh(force) {
    var m = model();
    var res = document.getElementById('dxpResults');
    if (!m || !res) { return; }
    var key = (m.generatedAt || '') + '|' + state.system + '|' + state.day;
    if (!force && key === state.key && document.getElementById('dxpExchangeCard')) { return; }
    if (state.busy) { return; }
    state.busy = true;
    load(state.system).then(function (data) {
      state.busy = false;
      state.key = key;
      render(m, data);
    }).catch(function () {
      state.busy = false;
      var c = document.getElementById('dxpExchangeCard');
      if (c && c.parentNode) { c.parentNode.removeChild(c); }
    });
  }

  function start() {
    state.system = defaultSystem();
    var res = document.getElementById('dxpResults');
    if (!res || !window.MutationObserver) { return; }
    var t = null;
    new MutationObserver(function (list) {
      var ours = list.every(function (r) {
        return [].slice.call(r.addedNodes).concat([].slice.call(r.removedNodes)).every(function (n) { return n.id === 'dxpExchangeCard'; });
      });
      if (ours) { return; }
      clearTimeout(t);
      t = setTimeout(function () { refresh(false); }, 250);
    }).observe(res, { childList: true });
    refresh(false);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
  window.DietXPExchanges = { refresh: function () { refresh(true); }, summary: summary };
})();
